const styles = theme => ({
  value: theme.mixins.gutters({
    margin: 0,
    fontWeight: 200
  }),
  pairSelector:{
    textAlign:'right',
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/common/results/components/pairSelector/styles.js